<template lang="pug">
	div.like(:class="activeClass")
		span.like__counter {{ count }}
		i.like__icon(@click="likeToggle")

</template>
<script>
	export default {
		name: 'like',
		props: ['_active','_count','_contentID','_contentName'],
		data: Vue => ({
			count: Vue._count,
			active: Vue._active,
		}),
		computed: {
			activeClass(){return this.active ? 'js-active':'' }
		},
		methods: {
			like(){
				this.$store.dispatch('postLike', { content_name:this._contentName, content_id: this._contentID })
					.then( response => this.active = response.data.id )
					.then( () => this.count+=1 )
			},
			dislike(){
				this.$store.dispatch('deleteLike', { id: this.active })
					.then( () => this.active = false )
					.then( () => this.count-=1 )
			},
			likeToggle(){ !this.active ? this.like() : this.dislike() },
		},
	}
</script>
